import { get } from 'lodash';
import { CLEAR_POSTS } from '../actions/clear-posts';
import { SET_IS_LOADED } from '../actions/set-is-loaded';
import { SET_IS_CATEGORY_LOADED } from '../actions/set-is-category-loaded';
import { FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_FAILURE } from '../actions/fetch-comments';
import { FETCH_POST_SUCCESS, FETCH_POST_FAILURE } from '../actions/fetch-post';
import {
  FETCH_LAST_FEATURED_POST_SUCCESS,
  FETCH_LAST_FEATURED_POST_FAILURE,
} from '../actions/fetch-last-featured-post';
import { FETCH_CATEGORY_POSTS_SUCCESS, FETCH_CATEGORY_POSTS_FAILURE } from '../actions/fetch-category-posts';
import { FETCH_USER_POSTS_SUCCESS, FETCH_USER_POSTS_FAILURE } from '../actions/fetch-posts-by-user';
import { FETCH_POSTS_BY_OTHERS_SUCCESS, FETCH_POSTS_BY_OTHERS_FAILURE } from '../actions/fetch-posts-by-others';
import { FETCH_USER_COMMENTS_SUCCESS, FETCH_USER_COMMENTS_FAILURE } from '../actions/fetch-comments-by-user';
import { FETCH_USER_LIKES_SUCCESS, FETCH_USER_LIKES_FAILURE } from '../actions/fetch-likes-by-user';
import { FETCH_FEED_POSTS_SUCCESS, FETCH_FEED_POSTS_FAILURE } from '../actions/fetch-feed-posts';
import { FETCH_POSTS_SUCCESS, FETCH_POSTS_FAILURE } from '../actions/fetch-posts';
import { FETCH_RECENT_POSTS_SUCCESS, FETCH_RECENT_POSTS_FAILURE } from '../actions/fetch-recent-posts';
import { FETCH_ARCHIVE_SUCCESS, FETCH_ARCHIVE_FAILURE } from '../actions/fetch-archive';
import { SAVE_POST_DRAFT_SUCCESS } from '../actions/save-post-draft';
import { CLEAN_POST_EDITOR_STATE, UPDATE_POST_EDITOR_POST } from '../actions/post-editor';
import { POST_STATUS } from '@wix/communities-blog-universal/dist/src/constants/post';

// eslint-disable-next-line complexity
export default function isLoaded(state = {}, action) {
  switch (action.type) {
    case SET_IS_LOADED:
      return setIsLoaded(state, action.payload);

    case SET_IS_CATEGORY_LOADED:
      return setIsLoaded(state, {
        entity: 'category',
        id: action.payload.categoryId,
        isLoaded: true,
      });

    case FETCH_POST_SUCCESS:
    case FETCH_POST_FAILURE:
      return setIsLoaded(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoaded: true,
      });

    case FETCH_LAST_FEATURED_POST_SUCCESS:
    case FETCH_LAST_FEATURED_POST_FAILURE:
      return setIsLoaded(state, {
        entity: 'last-featured-post',
        isLoaded: true,
      });

    case FETCH_USER_POSTS_SUCCESS:
    case FETCH_USER_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: get(action, 'meta.status') === POST_STATUS.unpublished ? 'profile-drafts' : 'profile-posts',
        id: action.payload.ownerId,
        isLoaded: true,
      });

    case FETCH_USER_COMMENTS_SUCCESS:
    case FETCH_USER_COMMENTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'profile-comments',
        isLoaded: true,
      });

    case FETCH_USER_LIKES_SUCCESS:
    case FETCH_USER_LIKES_FAILURE:
      return setIsLoaded(state, {
        entity: 'profile-likes',
        isLoaded: true,
      });

    case FETCH_FEED_POSTS_SUCCESS:
    case FETCH_FEED_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'feed-posts',
        isLoaded: true,
      });

    case FETCH_POSTS_SUCCESS:
    case FETCH_POSTS_FAILURE:
    case FETCH_POSTS_BY_OTHERS_SUCCESS:
    case FETCH_POSTS_BY_OTHERS_FAILURE:
      return setIsLoaded(state, {
        entity: 'posts',
        isLoaded: true,
      });

    case FETCH_RECENT_POSTS_SUCCESS:
    case FETCH_RECENT_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'recent-posts',
        id: action.meta.postId,
        isLoaded: true,
      });

    case CLEAR_POSTS:
      return {
        ...setIsLoaded(state, {
          entity: 'feed-posts',
          isLoaded: false,
        }),
        category: {},
      };

    case FETCH_CATEGORY_POSTS_SUCCESS:
    case FETCH_CATEGORY_POSTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'category',
        id: action.meta.categoryId,
        isLoaded: action.type === FETCH_CATEGORY_POSTS_SUCCESS,
      });

    case FETCH_COMMENTS_SUCCESS:
    case FETCH_COMMENTS_FAILURE:
      return setIsLoaded(state, {
        entity: 'comments',
        id: action.payload.postId,
        isLoaded: true,
      });

    case SAVE_POST_DRAFT_SUCCESS:
    case UPDATE_POST_EDITOR_POST:
      return setIsLoaded(state, {
        entity: 'postDraft',
        id: get(action, 'payload.draftKey', null),
        isLoaded: true,
      });

    case CLEAN_POST_EDITOR_STATE:
      return setIsLoaded(state, {
        entity: 'postDraft',
        id: get(action, 'payload', null),
        isLoaded: false,
      });

    case FETCH_ARCHIVE_SUCCESS:
    case FETCH_ARCHIVE_FAILURE:
      return setIsLoaded(state, {
        entity: 'archive',
        isLoaded: true,
      });

    default:
      return state;
  }
}

function setIsLoaded(state, { entity, id = '', isLoaded }) {
  const entityState = id
    ? {
        ...state[entity],
        [id]: isLoaded,
      }
    : isLoaded;

  return {
    ...state,
    [entity]: entityState,
  };
}
